export default class Title extends Phaser.GameObjects.Text {
	/**
   *  My custom dynamic bitmap text.
   *
   *  @constructor
   *  @class Title
   *  @extends Phaser.GameObjects.Text
   *  @param {Phaser.Scene} scene - The scene that owns this bitmap text.
   *  @param {number} x - The horizontal coordinate relative to the scene viewport.
   *  @param {number} y - The vertical coordinate relative to the scene viewport.
   *  @param {string} text - The text to display.
   *  @param {object} style - The style applied to text.
   * 
   */
	constructor(scene, x, y, text, style, shadow) {
		super(scene, x, y, 'title');
		//let textStyle = setup.styles.colorLetterStyle;
		this.setText(text || 'Title');
		this.setX(x || 10);
		this.setY(y || 10);
		this.setStyle(style);
		if (!shadow) shadow = { x: 2, y: 2, color: 'rgb(132,155,51)', fill: 0 };
		this.setShadow(shadow.offsetX, shadow.offsetY, shadow.color);
		//  Add this game object to the owner scene.
		scene.children.add(this);
	}
}
